<app-modal-base [title]="dialogTitle" [titleParams]="dialogTitleParams" [hasSubmit]="false" [cancelType]="'CLOSE'">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="formContainer">
      <!-- logo -->
      <app-company-logo-association [company]="company"></app-company-logo-association>
      <!-- users -->
      <app-company-user-association [company]="company"></app-company-user-association>
    </div>
  </div>
</ng-template>
